import { render, staticRenderFns } from "./evaluationPaperDetails.vue?vue&type=template&id=87cf8c40&scoped=true"
import script from "./evaluationPaperDetails.vue?vue&type=script&lang=js"
export * from "./evaluationPaperDetails.vue?vue&type=script&lang=js"
import style0 from "./evaluationPaperDetails.vue?vue&type=style&index=0&id=87cf8c40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cf8c40",
  null
  
)

export default component.exports